import {AbstractControl, ValidationErrors} from '@angular/forms';
import { Observable, of } from 'rxjs';
export class ValidationService {

  static panValidator(control: any) {
    if (!control.value) {
      return { 'invalidPAN': true }; 
    }
    const panPattern = /^[a-zA-Z]{3}[pP][a-zA-Z]{1}\d{4}[a-zA-Z]{1}$/;
    if (control.value.match(panPattern)) {
      return null;
    } else {
      return { 'invalidPAN': true };
    }
  }
  

  static emailValidator(control: any) {
    const value = control.value;

    if (!value) return of(null);

    const emailRegex = /^[a-zA-Z0-9._@]+$/;
    if (!emailRegex.test(value)) {
      return of({ 'invalidEmailAddress': true });
    }

    // a. Should start with a letter
    // if (!/^[a-zA-Z]/.test(value)) {
    //   return of({ 'invalidEmailAddress': true });
    // }

    // b. Only allow letters, digits, ., _, and @
    if (/[^a-zA-Z0-9._@]/.test(value)) {
      return of({ 'invalidEmailAddress': true });
    }

    // c. Only one @
    if ((value.match(/@/g) || []).length !== 1) {
      return of({ 'invalidEmailAddress': true });
    }

    // d. Domain must be valid: at least 1 char before '.', and at least 2 alphabets after '.'
    const domainPattern = /@([a-zA-Z0-9-]+\.)+([a-zA-Z]{2,})$/;
    if (!domainPattern.test(value)) {
      return of({ 'invalidEmailAddress': true });
    }
    return of(null);
  }


  static numberValidator(control: any) {
    // RFC 2822 compliant regex
    if (control.value.match( '^[#(0-9)-\/]*$' )) {
      return null;
    } else {
      return { 'invalidPhoneNumber': true };
    }
  }

  static alphaNumeric(control: any){
    if (control.value.match(/[a-zA-Z0-9]/)) {
      return null;
    } else {
      return { 'invalidData': true };
    }
  }
  static isTenAsync(control: any) {
    const v: number = control.value.length;
    if (v === 6) {
    // Emit an object with a validation error.
    return of(null);

    }
    else{
      return of({ 'length': true});

    }
    // Emit null, to indicate no error occurred.
  }

  static nomineepanValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    const panRegex = /^[A-Z]{3}P[A-Z][0-9]{4}[A-Z]$/;
    if (!value) return { required: 'Identification document no. is mandatory' };
    if (/\s/.test(value)) return { invalidPAN: 'Please enter a valid PAN' };
    return panRegex.test(value.toUpperCase()) ? null : { invalidPAN: 'Please enter a valid PAN' };
  }

  static dlValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    const dlRegex = /^[A-Z]{2}[0-9A-Z\s-]*[0-9A-Z]$/;
    if (!value) return { required: 'Identification document no. is mandatory' };
    if (/[-\s]$/.test(value)) return { invalidDL: 'Please enter a valid Driving License number' };
    return /^[A-Z]{2}/.test(value) ? (dlRegex.test(value) ? null : { invalidDL: 'Please enter a valid Driving License number' }) : { invalidDL: 'Please enter a valid Driving License number' };
  }

  static aadhaarValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    if (!value) return { required: 'Identification document no. is mandatory' };
    if (!/^\d{4}$/.test(value)) return { invalidAadhaar: 'Please enter last 4 digit of Aadhaar' };
    return null;
  }

  static passportValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    if (!value) return { required: 'Identification document no. is mandatory' };
    if (/[-\s]$/.test(value)) return { invalidPassport: 'Please enter a valid passport number' };
    return /^[A-Za-z0-9][A-Za-z0-9\s-]*$/.test(value) ? null : { invalidPassport: 'Please enter a valid passport number' };
  }

}
